import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { QualificationCategoryV2Service } from '@wilson/api/gateway';
import { TransformMasterDataTranslationService } from '@wilson/non-domain-specific/master-data-translate';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseSelectFilterDirective } from '../../base-select-filter.directive';
import { FilterService } from '../../filter.service';
import { FilterOptions } from '../../options.interface';
import { MultiSelectParserService } from '../../services/multi-select-parser.service';

@Component({
  selector: 'wilson-qualification-v2-category-filter',
  templateUrl: './qualification-v2-category-filter.component.html',
  styleUrls: ['./qualification-v2-category-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzSelectModule, TranslatePipe, CommonModule, FormsModule],
  providers: [TransformMasterDataTranslationService],
})
export class QualificationV2CategoryFilterComponent extends BaseSelectFilterDirective<
  FilterOptions,
  string[]
> {
  protected readonly filterService = inject(FilterService);
  protected readonly parserService = inject(MultiSelectParserService);
  private readonly qualificationV2CategoryService = inject(
    QualificationCategoryV2Service,
  );
  private readonly transformMasterDataTranslationService = inject(
    TransformMasterDataTranslationService,
  );

  constructor() {
    super('qualificationV2Category');
  }

  protected initializeOptions(): Observable<FilterOptions[]> {
    return this.qualificationV2CategoryService.getCategories().pipe(
      map((categories) => {
        const transformedCategories = this.transformMasterDataTranslationService
          .transform(categories)
          .map((category) => ({
            id: category.id,
            name: category.translatedName,
          }));
        return transformedCategories;
      }),
    );
  }
}
